import { DatePicker } from '@shared/ui/kit';
import type { DatePickerInputStatus } from '@shared/ui/kit/date-picker/model/types';
import { LockedDateField } from '@shared/ui/locked-date-field';
import styles from './ticket-date-field.module.scss';

interface TicketDateFieldProps {
  isTicketDateDisabled: boolean;
  isSkipTicketSendChecked: boolean;
  isLocked: boolean;
  ticketDate: Date | null;
  ticketDatePickerStatus: DatePickerInputStatus;
  ticketDatePickerInputMessage?: string;
  onTicketDateChange: (dates: [Date | null, Date | null]) => void;
}

export const TicketDateField = ({
  isTicketDateDisabled,
  isSkipTicketSendChecked,
  isLocked,
  ticketDate,
  ticketDatePickerStatus,
  ticketDatePickerInputMessage,
  onTicketDateChange,
}: TicketDateFieldProps) => {
  if (isTicketDateDisabled) {
    return (
      <div className={styles.dateWrapperLocked}>
        <LockedDateField
          label="Дата отправки билета"
          date={isSkipTicketSendChecked && !isLocked ? null : ticketDate}
          emptyValue="-"
        />
      </div>
    );
  }

  return (
    <DatePicker
      labelText="Дата отправки билета"
      size="small"
      isRange={false}
      selectedDate={ticketDate}
      setNewSelectedDate={onTicketDateChange}
      inputStatus={ticketDatePickerStatus}
      inputMessage={ticketDatePickerInputMessage ?? undefined}
    />
  );
};
